import nextPrevBackground from '../../../assets/js/_next-prev-background.js';

function mediaContent( nodes = '.media-content', settings = {} ) {
	if ( typeof nodes === 'string' ) {
		nodes = Array.from( document.querySelectorAll( nodes ) );
	} else if ( nodes instanceof HTMLElement ) {
		nodes = [ nodes ];
	}

	if ( nodes && nodes.length ) {
		nodes.forEach( ( node ) => {
			if ( node.classList.contains( 'media-content--pull' ) ) {
				nextPrevBackground( node );
			}
		} );
	}

	return nodes;
}

document.addEventListener( 'DOMContentLoaded', () => mediaContent() );

export default mediaContent;
